<template>
    <div class="box">
        <div style="display: flex;width:100%">
            <vue-ueditor-wrap :id="id" v-model="msg" :config="myConfig" :destroy="true" @beforeInit="addCustomButtom"
                :style="{'display': 'inline-block', 'width':( errorList.length==0?'100%':'75%'), 'vertical-align': 'top',}">
            </vue-ueditor-wrap>
            <div class='errorListInner'>
                <div class='error_num'>
                    <div
                        style="width: 4px;height: 18px;background: #106AFF;display: inline-block;margin-left:-20px;margin-right:20px">
                    </div>
                    <span>校对结果：</span>
                    <a-button style="background: #ffffff;color:#323233;margin-right:5px">全部恢复</a-button>
                    <a-button
                        style="background: #FF5E5D;color:#fff;margin-right:10px">
                        替换全部
                    </a-button>
                    <a-button @click="btnProAll" style="background:#F65B5A;color:#fff;margin-right:10px">开始校对</a-button>
                    <!-- <span  style="color:#FFA339">{{errorList.length}}个</span>错误提示-->
                </div>
                <div style="display: flex;justify-content: space-between;align-items: center;padding:16px 20px">
                    <div class="listerror" v-for="(item,i) in 4 " :key="i" @click="listerror(i)">
                        <h2 :style="num==i ? 'font-weight: bold;color: #106AFF;':''">13</h2>
                        <p v-if="i==0" :style="num==i ? 'font-weight: bold;color: #106AFF;':''">所有错误</p>
                        <p v-if="i==1" :style="num==i ? 'font-weight: bold;color: #106AFF;':''">拼写纠错</p>
                        <p v-if="i==2" :style="num==i ? 'font-weight: bold;color: #106AFF;':''">语法纠错</p>
                        <p v-if="i==3" :style="num==i ? 'font-weight: bold;color: #106AFF;':''">标点纠错</p>
                    </div>
                </div>
                <!-- <div class='error_num' v-if="errorList.length==0">错误列表</div> -->
                <div id='panelInfo'>
                    <ul class='errorList' :style="{'height':errorListheight}">
                        <li v-for="(item,key) in errorList " :key="key" :class="{red:nowIndex===key}"
                            @click="liGroup(item,key)">
                            <div>
                                <div
                                    style="display: inline-block;width:calc(100% - 88px);font-size:12px;vertical-align:middle">
                                    <span style="display: inline-block;">{{key+1}}.</span>
                                    <span v-if="item.level === 2" class='iserror'>疑错</span>
                                    <span v-if="item.level === 1" class='errorLow'>错误</span>
                                    <span v-if="item.level === 3" class='error'>严重错误</span>
                                    <!-- 方寸-->
                                    <span
                                        v-if="item.level === '1000'||item.level === '1001'||item.level === '1003'||item.level === '1005'||item.level === '3001'||item.level === '4000'||item.level === '5000'||item.level === '7001'||item.level === '7002'"
                                        class='zz_error'>{{item.error_type}}</span>
                                    <span v-if="item.level === '2000'||item.level === '2001'||item.level === '3000'"
                                        class='zz_error1'>{{item.error_type}}</span>
                                    <span>{{item.error_word}}——<span
                                            style="color:#6595FF;font-weight:600">{{item.right_words[0]}}</span></span>
                                </div>
                                <div style="display:inline-block;vertical-align:middle">
                                    <div class='btn-edit' @click="btnrecover(item,key)">修改</div>
                                    <div class='btn-recover' @click="btnupdate(item,key)">恢复</div>
                                </div>
                            </div>
                        </li>
                    </ul>
                </div>

                <div class="btn">
                    <a-button type="primary" style="margin-right:10px">保存并退出</a-button>
                    <a-button>退出审核</a-button>
                </div>
            </div>
        </div>

        <!-- 抽屉盒子 -->
        <a-drawer title="千虑云校对参数设置" :width="720" :visible="drawer" @close="onClose">
            <a-row>
                <a-col :span="24">
                    <a-checkbox :indeterminate="isIndeterminate" :checked="checkAll" @change="handleCheckAllChange">全选
                    </a-checkbox>
                    <a-col :span="24" class='font_type1'>检查类型</a-col>
                    <a-col :span="24">
                        <a-checkbox-group v-model="checkedtypes" :options="checkes" @change="handleCheckedChange" />
                    </a-col>
                    <a-col :span="24" class='font_type1'>校对模式</a-col>
                    <a-col :span="24">
                        <a-radio-group v-model="checkoutprotype" :options="protype" @change="handleCheckedProChange" />
                    </a-col>
                    <a-col :span="24" class='font_type1'>检查参数</a-col>
                    <a-col :span="24">
                        <a-checkbox-group v-model="checkouterrortype" :options="errortype"
                            @change="handleCheckedErrorChange" class="checkbox-block" />
                    </a-col>
                    <!-- <a-col :span="24" class='font_type1'>AI引擎校对</a-col>
                <a-col :span="24">
                    <a-radio-group v-model="checkoutAi" :options="Ai" @change="handleCheckedAi" />
                </a-col> -->
                </a-col>
            </a-row>
            <div :style="{
          position: 'absolute',
          right: 0,
          bottom: '8px',
          width: '100%',
          borderTop: '1px solid #e9e9e9',
          padding: '10px 16px',
          background: '#fff',
          textAlign: 'right',
          zIndex: 1,
          wordNum:0
        }">
                <a-button :style="{ marginRight: '8px' }" @click="onClose">
                    取消
                </a-button>
                <a-button type="primary" @click="handleParameter">
                    确定
                </a-button>
            </div>
        </a-drawer>
        <!--进度条 -->
        <a-modal class='progress_dialog' title="提示" :visible="dialogVisible" width="30%" :before-close="handleClose">
            <a-progress type="circle" :percent="percentage" :stroke-color="colors" :width="250" :height='250'>
            </a-progress>
        </a-modal>
    </div>
</template>

<script>
    import VueUeditorWrap from 'vue-ueditor-wrap';
    // import { saveAs } from 'file-saver';
    // import { getProofResult,createProof,getMyPlatform} from "@/api/website";
    const checkesOptions = ['检查内容', '检查领导人排序', '标点符号检查'];
    const protypeOptions = [{
        'label': '快速校对',
        'value': 0
    }, {
        'label': '正常校对',
        'value': 1
    }, {
        'label': '严格校对',
        'value': 2
    }];
    const aiPro = [{
        'label': '关闭',
        'value': 0
    }, {
        'label': '开启',
        'value': 1
    }]
    const checkouterrorOptions = ['检查英文单词拼写错误', '检查自定义错误', '检查政治性错误', '检查领导人和重点词', '检查曾用词']
    export default {
        data() {
            return {
                num: -1,
                content: '',
                msg: '',
                myConfig: {
                    toolbars: [
                        [
                            'undo', //撤销
                            'bold', //加粗
                            'autotypeset', //自动排版
                            'indent', //首行缩进
                            'italic', //斜体
                            'underline', //下划线
                            'fontfamily', //字体
                            'fontsize', //字号
                            'justifyleft', //居左对齐
                            'justifycenter', //居中对齐
                            'justifyright', //居右对齐
                            'justifyjustify', //两端对齐
                            'insertorderedlist', //有序列表
                            'insertunorderedlist', //无序列表
                            'lineheight', //行间距
                        ]
                    ],
                    // 编辑器不自动被内容撑高
                    autoHeightEnabled: false,
                    // 初始容器高度
                    initialFrameHeight: window.innerHeight - 53 - 40 - 57,
                    retainOnlyLabelPasted: true,
                    // 初始容器宽度
                    initialFrameWidth: '100%',
                    removeEmptyline: true, //去掉空行
                    asteFilter: true, //根据规则过滤没事粘贴进来的内容
                    // 上传文件接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
                    serverUrl: 'http://localhost:8080',
                    // UEditor 资源文件的存放路径，如果你使用的是 vue-cli 生成的项目，通常不需要设置该选项，vue-ueditor-wrap 会自动处理常见的情况，如果需要特殊配置，参考下方的常见问题2
                    UEDITOR_HOME_URL: '/UE/'
                },
                checkAll: false,
                checkedtypes: ['检查内容', '检查领导人排序', '标点符号检查'],
                checkoutprotype: 1,
                checkoutAi: 0,
                checkouterrortype: ['检查英文单词拼写错误', '检查自定义错误', '检查政治性错误', '检查领导人和重点词', '检查曾用词'],
                errorList: [], //错误列表
                checkes: checkesOptions,
                protype: protypeOptions,
                Ai: aiPro,
                errortype: checkouterrorOptions,
                isIndeterminate: true,
                drawer: false,
                direction: 'rtl',
                CheckLeaderSort: '1', //检查领导人排序
                FanTi: '1', //检查曾用词
                UserErr: '1', //检查自定义错误
                ChkEng: '1', //检查英文单词拼写错误
                TaiWan: '1', //检查政治性错误
                Leader: '1', //检查领导人和重点词
                CheckSentence: '1', //检查内容
                CheckMatchDots: '1', //标点符号检查
                changehtml: '', //校对的错误内容
                chckMap: {}, //匹配错误的列表
                percentage: 0,
                nowIndex: null,
                beforeWord: {},
                colors: {
                    '20%': 'rgba(101, 149, 255, 0.4)',
                    '40%': 'rgba(101, 149, 255, 0.5)',
                    '60%': 'rgba(101, 149, 255, 0.6)',
                    '80%': 'rgba(101, 149, 255, 0.8)',
                    '100%': 'rgba(101, 149, 255, 1)',
                },
                dialogVisible: false,
                times: 0,
                originContent: '',
                id: 'editor',
                ue: '',
                beforeIndex: '', //前面一个词组的索引
                beforeColor: '', //前面一个词组的背景颜色
                errorListheight: '',
                isError: false,
                wordBalance: ''
            }
        },
        name: 'app',
        components: {
            VueUeditorWrap
        },
        mounted() {},
        methods: {
            listerror(val) {
                this.num = val
            },
            addCustomButtom(editorId) {
                this.ue = editorId
                var _that = this
                // console.log(UE,'mmmmm')
                window.UE.plugins["addoutline"] = function () {
                    console.log(this, 'nnnnnnnnnnnn')
                    var me = this;
                    // var beforeIndex ='';
                    // var beforeColor='';
                    //创建一个改变图片边框的命令
                    me.commands["addoutline"] = {
                        execCommand: function () {
                            //获取当前选区
                            var range = me.selection.getRange();
                            var initNode = range.getCommonAncestor();
                            // console.log(range,initNode,initNode.parentNode.className, 'mmmmm')
                            // console.log(range, initNode, 'mmmmm')
                            if (initNode.nodeType === 3) {
                                initNode = initNode.parentNode;
                            }

                            // $(me.body).find('.view_item').removeClass('focus');
                            if (initNode.className != '') {
                                console.log(initNode.className, '11111111111')
                                var num = parseInt(initNode.className.split('check-span')[1]) - 1;
                                // console.log(this.beforeIndex,this.beforeColor,'mmmmm')
                                if (_that.beforeIndex) {
                                    document.getElementsByClassName('errorList')[0].children[_that
                                        .beforeIndex - 1].removeAttribute("class", '')
                                }
                                if (_that.beforeColor) {
                                    // console.log(me,'kkkkkkkkkkk')
                                    var element = me.iframe.contentDocument.body.getElementsByClassName(
                                        'check-span' + _that.beforeIndex)[0];
                                    element.style.background = _that.beforeColor;
                                    // $('.check-span' + this.beforeIndex).css('background-color', this.beforeColor)
                                }
                                if (initNode.localName == 'span') {

                                    _that.beforeIndex = num + 1;
                                    _that.beforeColor = initNode.style.backgroundColor; //前面一个词组的背景颜色
                                    console.log(_that.beforeIndex, _that.beforeColor, 'mmmmmmmmm')
                                    document.getElementsByClassName('errorList')[0].children[num]
                                        .setAttribute('class', 'red')
                                    initNode.style.backgroundColor = '#b2caff'
                                    document.getElementsByClassName('errorList')[0].children[num]
                                        .scrollIntoView({
                                            behavior: "smooth",
                                            block: "center",
                                            inline: "nearest"
                                        });
                                }
                            }
                        },
                        queryCommandValue: function () {
                            return '111';
                        }
                    };
                    me.addListener('click', function () {
                        setTimeout(function () {
                            me.execCommand("addoutline");
                        })

                    });
                };
            },
            //一键校对
            btnProAll() {
                // ===========================检查类型============================== 
                // this.chckMap = {}
                // this.ClarBackGroup()
                this.btnRemoveStyle()
                var content = this.msg
                if (content == '') {
                    this.$message.error('校对内容不能为空!');
                    return false;
                }
                this.dialogVisible = true;
                this.isError = false;
                this.postContent()

            },
            //提交校验的内容
            postContent() {
                let contentAll = UE.getEditor(this.ue).getContentTxt();
                this.wordNum = contentAll.length;
                console.log(contentAll, 'mmmm')
                var datas = {
                    "CheckLeaderSort": this.CheckLeaderSort,
                    "CheckMatchDots": this.CheckMatchDots,
                    "CheckSentence": this.CheckSentence,
                    "ChkDefault": "1",
                    "ChkEng": this.ChkEng,
                    "ChkReturnResultType": "2",
                    "FanTi": this.FanTi,
                    "HtmlTag": "1",
                    "Leader": this.Leader,
                    "Needsug": "1",
                    "ProfType": "1",
                    "TaiWan": this.TaiWan,
                    "UserErr": this.UserErr,
                    "Weight": (this.checkoutprotype).toString(),
                    'aiEngine': this.checkoutAi,
                    "content": contentAll,
                }
                console.log(datas, 'kkkkkkkkkk')
                createProof({}, datas).then(res => {
                    console.log(res, 'res');
                    if (res.status) {
                        this.getResult(res.data)
                    } else {
                        this.$message.error(res.message);
                    }
                }).catch(err => {
                    console.log(err, 'err');
                })
            },
            //获取校验结果
            getResult(token) {
                // let contentAll = this.myEditor.getContent().replace(/<[^>]+>/g, "").replace(/&nbsp;/ig, "");
                let contentAll = UE.getEditor(this.ue).getContentTxt();
                var id = token;
                var datas = {
                    'proofDocumentId': id
                };
                let that = this;
                getProofResult(datas).then(result => {
                    that.getPlatform();
                    // console.log(result,'result');
                    if (result.data.proofStatus == 1) {
                        let percent = result.debug;
                        this.percentage = parseInt(percent.split('进度')[1].split('%')[0]);
                        // console.log( parseInt(percent.split('进度')[1].split('%')[0]))
                        this.getResult(id)
                    } else {
                        this.dialogVisible = false;
                        this.percentage = 0;
                        var CheckResultList = result.data.proofResult;
                        this.errorList = CheckResultList;
                        if (CheckResultList.length == 0) {
                            this.errorList = [];
                            this.percentage = 0
                            this.$message.error('没有校对出错误的词汇。')
                            this.isError = true;
                        } else {
                            var listAll = result.data.proofResult;
                            var list = [];
                            //判断是否包含特殊字符
                            var flag = new RegExp(
                                "[`~!@#$^&*()=|{}':;',\\[\\].<>《》/?~！@#￥……&*（）——|{}【】‘；：”“'。，、？ ]")
                            for (let j in listAll) {
                                // console.log(flag.test(listAll[j].error_word),'不包含！不包含！')
                                // if(listAll[j].level!=2){
                                // if(flag.test(listAll[j].error_word)){

                                // }else{
                                list.push(listAll[j])

                                // }
                                // }
                            }

                            var newArr = [list[0]];
                            // =========优先黑马
                            // for (var i = 1; i < list.length; i++) {
                            //     var num1 = parseInt(list[i - 1].offset) + list[i - 1].error_word.length;
                            //     var num2 = parseInt(list[i].offset);
                            //     // typeof (list[i].level) == 'string'
                            //     if (num1 > num2) {
                            //         // console.log(list[i-1].error_word,list[i].error_word,i,'kkkk')
                            //         // newArr.push(list[i-1])
                            //         // i++
                            //     } else {
                            //         // console.log(list[i].error_word,i,'2222222')
                            //         newArr.push(list[i])
                            //     }
                            // }
                            // ===========优先方寸
                            var newArr = [list[0]];
                            for (var i = 1; i < list.length; i++) {
                                if (parseInt(list[i].offset) == parseInt(newArr[newArr.length - 1].offset)) {
                                    // console.log(list[i].error_word, '1111111')
                                    if (list[i].level == '1000' || list[i].level == '3000') {
                                        // console.log(list[i].error_word, '1111111')
                                        newArr[newArr.length - 1] = list[i]
                                    }
                                } else {
                                    if (parseInt(list[i].offset) > parseInt(newArr[newArr.length - 1].offset) +
                                        newArr[newArr.length - 1].error_word.length) {
                                        newArr.push(list[i])
                                    } else {
                                        // console.log(list[i].error_word)
                                    }
                                }
                            }
                            // console.log(newArr,'去除掉')
                            this.errorList = newArr;
                            // this.chckMap = newArr;
                            // this.drawer = false;
                            this.$message.success("本次校对：" + newArr.length + "个错误");

                            this.dealResult(newArr)
                        }
                    }

                }).catch(err => {
                    console.log(err, 'err');
                })
            },
            Add_Map(id, data) {
                // let chckMap = {};
                if (!this.chckMap.hasOwnProperty(id)) {
                    this.chckMap[id] = data;
                }
            },
            getUmEditWay() {
                var umEditWay = 2;
                if (localStorage.getItem("umEditWay") != null) {
                    umEditWay = localStorage["umEditWay"];
                }
                return umEditWay;
            },
            getErrStr(str, level, id) {
                var innerHtml = "";
                if (level == 1 || level === '1000' || level === '1001' || level === '1003' || level === '1005' ||
                    level === '3001' || level === '4000' || level === '5000' || level === '7001' || level === '7002') {
                    innerHtml += '<span class="check-span' + id + '"  style="background-color:#ffd3a3;">' + str +
                        "</span>";
                } else if (level == 3 || level === '2000' || level === '2001' || level === '3000') {
                    innerHtml += '<span class="check-span' + id + '"  style="background-color:#ffd3a3;">' + str +
                        "</span>";
                } else {
                    innerHtml += '<span class="check-span' + id + '"  style="background-color:#ffd3a3;">' + str +
                        "</span>";
                }
                // console.log(innerHtml, 'mmmmmm')
                return innerHtml;
            },
            getLevelStr(level) {
                var innerHtml = "";
                if (level == 1 || level === '1000' || level === '1001' || level === '1003' || level === '1005' ||
                    level === '3001' || level === '4000' || level === '5000' || level === '7001' || level === '7002') {
                    innerHtml +=
                        '<span class="badge" style="background-color:#ffd3a3;color:black;">错误</span>';
                } else if (level == 3 || level === '2000' || level === '2001' || level === '3000') {
                    innerHtml +=
                        '<span class="badge" style="background-color:#ffd3a3;color:black;">严重错误</span>';
                } else {
                    innerHtml +=
                        '<span class="badge" style="background-color:#ffd3a3;color:black;">疑错</span>';
                }
                return innerHtml;
            },
            //处理结果
            dealResult(data) {
                // let contentAllnew = this.myEditor.getContent(); //获取编辑器的内容
                var innerHtml = "";
                var content_New = "";
                var curPos_Format = 0; // 当前带格式文本的指针
                var curPos_text = 0; //当前不带文本的指针
                var tCount = 0;
                var umEditWay = this.getUmEditWay();
                var contentTxt = UE.getEditor(this.ue).getContentTxt(); //提交校对的文本

                var contentFomat = UE.getEditor(this.ue).getContent(); //带格式的文本
                tCount = data.length;

                for (var i = 0; i < data.length; i++) {
                    var tempStr = "";
                    var errWordNew = ""; //临时存放转换的errWord
                    var leftPos = 0; //左边扩充字符数
                    var rightPos = 0; //右边扩充字符数
                    var k = i + 1;
                    var pos = 0;
                    var posFlag = 0;
                    // console.log(data[i],i,'mmm')
                    var level = data[i].level;
                    var errWord = data[i].error_word;
                    var colWordList = data[i].right_words;
                    // console.log(colWordList,'colWordList')
                    if (i > 0) {
                        var error_wordBefore = data[parseInt(i) - 1].error_word;
                        if (error_wordBefore.length > 1) {
                            var pos_beforeOld = data[parseInt(i) - 1].offset + error_wordBefore.length - 1;
                        } else {
                            var pos_beforeOld = data[parseInt(i) - 1].offset;
                        }
                    }
                    var pos_old = data[i].offset;
                    var pos_origin = data[i].offset;
                    var beforeWords = '';
                    var beforeWords1 = '';
                    var beforeWords2 = "";
                    // console.log(pos_old,'pos_old')
                    this.Add_Map(k, data[i]); //加入map
                    for (var j = 0; j < colWordList.length; j++) {
                        if (colWordList[j] != "") {
                            tempStr = tempStr + colWordList[j] + ",";
                        }
                    }
                    if (tempStr.length == 1) {
                        tempStr = "";
                    } else {
                        tempStr = tempStr.substr(0, tempStr.length - 1);
                    }
                    // console.log(pos_old - curPos_Format, errWord.length,'curPos_Format')
                    // console.log(contentFomat.substr(pos_old - curPos_Format, errWord.length),'mmm')
                    if (pos_old - curPos_Format >= 0 && pos_old - curPos_Format < contentFomat.length) {
                        var str = contentFomat.substr(pos_old - curPos_Format, errWord.length);
                        // console.log(str,errWord,'strmmmm')
                        if (str == errWord) {
                            posFlag = 1;
                            pos = pos_old - curPos_Format;
                        }
                    }
                    if (posFlag == 0) {
                        var pos_Temp = 0;
                        pos_old = pos_old - curPos_text;
                        errWordNew = errWord;
                        if (pos_old < contentTxt.length) {
                            var str = contentTxt.substr(pos_old, errWord.length);
                            if (str == errWord) {
                                while (true) {
                                    if (errWordNew.length >= 4)
                                        break;
                                    if (pos_old - leftPos > 0) {
                                        str = contentTxt.substr(pos_old - leftPos - 1, 1);
                                        if (str == ">" || str == "<") {
                                            break;
                                        } else {
                                            leftPos += 1;
                                            errWordNew = str + errWordNew;
                                        }
                                    } else {
                                        break;
                                    }
                                }
                                while (true) {
                                    if (errWordNew.length >= 4)
                                        break;
                                    if (pos_old + rightPos < contentTxt.length) {
                                        str = contentTxt.substr(pos_old + rightPos + 1, 1);
                                        if (str == ">" || str == "<") {
                                            break;
                                        } else {
                                            rightPos += 1;
                                            errWordNew = errWordNew + str;
                                        }
                                    } else {
                                        break;
                                    }
                                }
                            }
                            // console.log(leftPos,'leftPosleftPos')
                            if (leftPos > 0) {
                                pos_old = pos_old + leftPos;
                            }
                            contentTxt = contentTxt.substr(pos_old + errWord.length);
                            // console.log(contentTxt,'contentTxt')
                            curPos_text = curPos_text + pos_old + errWord.length;
                            // console.log(curPos_text,'curPos_text')
                        }
                    }
                    if (posFlag == 0) {
                        // console.log(pos,'pos1')
                        pos = contentFomat.indexOf(errWordNew);
                        // console.log(pos,leftPos,pos_old,'pos')
                        if (pos > 0) {
                            if (leftPos > 0) {

                                pos = leftPos + pos;
                            } else if (leftPos == 0 && typeof (level) == 'string') {
                                console.log(typeof (level), 'mmmm')
                                // console.log(pos, errWord, 'mmmm')
                                // var numKong = this.myEditor.getContentTxt().substr(0,pos_origin).match(/ /g)
                                // if(numKong=='null'){
                                //     pos_origin = pos_origin
                                // }else{
                                //     pos_origin = numKong.length+pos_origin
                                // }
                                var matches = contentFomat.match(new RegExp(errWordNew, "g"));
                                if (matches.length > 1) {
                                    if (pos_origin - 2 == pos_beforeOld) {
                                        beforeWords = UE.getEditor(this.ue).getContentTxt().substr(pos_origin - 1, 1)
                                    } else {
                                        beforeWords = UE.getEditor(this.ue).getContentTxt().substr(pos_origin - 2, 2)
                                    }
                                    // console.log(beforeWords, 'mmmm')
                                    if (UE.getEditor(this.ue).getContentTxt().substr(pos_origin, 1) != errWordNew
                                        .substr(0, 1)) {
                                        beforeWords1 = UE.getEditor(this.ue).getContentTxt().substr(pos_origin, 1);
                                        // console.log(beforeWords1, 'ppp')
                                        pos = contentFomat.match(new RegExp(beforeWords + beforeWords1 + errWordNew,
                                            "i")).index + 3;
                                    } else {
                                        // console.log(contentFomat, pos_beforeOld, pos_origin, beforeWords + beforeWords1 + errWordNew, 'lll')
                                        pos = contentFomat.match(new RegExp(beforeWords + beforeWords1 + errWordNew,
                                            "i")).index + beforeWords.length;
                                    }
                                    // console.log(beforeWords,this.myEditor.getContentTxt().substr(pos_origin-2,1),this.myEditor.getContentTxt().substr(pos_origin,1),'beforeWordsbeforeWordsbeforeWordsbeforeWords')
                                    // beforeWords += this.myEditor.getContentTxt().substr(pos_origin-1,1)
                                    // console.log(beforeWords,'beforeWords')
                                    // return

                                    // console.log(contentFomat.match(new RegExp(beforeWords+beforeWords1+errWordNew, "i")).index,'new')
                                }

                            } else {
                                pos = contentFomat.indexOf(errWord);
                            }

                        } else {
                            pos = contentFomat.indexOf(errWord);
                            // console.log(pos,errWord,'pos2')
                        }
                        if (pos <= -1) {
                            // console.log(errWord, pos_old, 'mmmm')
                            var tempPos = -2;
                            var temperr = ""; //找不到的字符可能存在换行
                            for (var m = 0; m < errWord.length; m++) {
                                temperr += errWord.substr(m, 1);
                                tempPos = contentFomat.indexOf(temperr + "</p>");
                                if (tempPos > -1) {
                                    pos = -2;
                                    break;
                                }
                            }
                            // console.log(temperr, 'temperr')
                        }
                    }

                    if (pos > -1) {
                        var tempsubStr = contentFomat.substr(0, pos); //截取pos之前的
                        // console.log(tempsubStr,'tempsubStr')
                        // console.log(beforeWords, 'beforeWords')
                        // console.log(beforeWords1, 'beforeWords1')

                        content_New += tempsubStr;
                        content_New += this.getErrStr(errWord, level, k);
                        if (pos + errWord.length < contentFomat.length) {
                            contentFomat = contentFomat.substr(pos + errWord.length);
                            // console.log(pos + errWord.length,'pos + errWord.lengthpos + errWord.length')
                            curPos_Format = pos + errWord.length;
                        }
                        // innerHtml += '<ul class="list-group"  >	<li class="list-group-item" name="liGroup" onclick="liGroup(' + k + ')" id="#liGroup' + k + '">';
                        // innerHtml += this.getLevelStr(level);
                        // innerHtml += "<h6>" + k.toString() + "&nbsp;&nbsp;词组:" + errWord + "</h6>";
                        // innerHtml += "<h6>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;建议：" + tempStr +
                        //     '<a href="#check-span' + k + '"><button onclick="btnrecover(' + k + ')" id="btnrecover' + k + '" name="recover_Batch" type="button" class="btn btn-default btn-xs" style="float:right" >恢复</button></a>' +
                        //     '&nbsp;&nbsp;&nbsp;&nbsp;<a href="#check-span' + k + '"><button onclick="btnupdate(' + k + ')" id="btnupdate' + k + '" name="checkUpdate_Batch" type="button" class="btn btn-default btn-xs" style="float:right" >修改</button></a></h6>';
                        // innerHtml += "</li></ul>";
                    } else if (pos == -2) {
                        tCount -= 1;
                        // innerHtml = "";
                    } else {
                        // innerHtml += '<ul class="list-group" >	<li class="list-group-item" style="background-color:#FFC0CB;"    name="liGroup" id="#liGroup' + k + '">';
                        // innerHtml += this.getLevelStr(level);
                        // innerHtml += "<h6>" + k.toString() + "&nbsp;&nbsp;词组:" + errWord + "</h6>";
                        // innerHtml += "<h6>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;建议：" + tempStr +
                        //     '<a href="#check-span' + k + '"><button onclick="btnrecover(' + k + ')" id="btnrecover' + k + '" name="recover_Batch" type="button" class="btn btn-default btn-xs" style="float:right" disabled>恢复</button></a>' +
                        //     '&nbsp;&nbsp;&nbsp;&nbsp;<a href="#check-span' + k + '"><button onclick="btnupdate(' + k + ')" id="btnupdate' + k + '" name="checkUpdate_Batch" type="button" class="btn btn-default btn-xs" style="float:right" disabled >修改</button></a></h6>';
                        // innerHtml += "</li></ul>";
                    }

                }

                content_New += contentFomat; //将剩余的和新的校对结果组合
                // $("#panelInfo").html(innerHtml);
                this.changehtml = innerHtml;
                UE.getEditor(this.ue).setContent(content_New, false);
                // this.callBack_mousemove();
                // this.callBack_update();
                // this.callBack_recover();
            },
            //每个子选项编辑器定位
            liGroup(item, key) {
                // var tid = $(this).attr('id');
                // var k = tid.substr(8);
                // document.querySelector('#check-span' + k).scrollIntoView();

                // var container = $("#myEditor");
                // container.scrollTop(container.scrollTop() - 30);
                // if (this.beforeColor == '') {

                // }
                // console.log(this.beforeWord,this.beforeColor ,this.beforeIndex,'11111111')
                if (Object.keys(this.beforeWord).length != 0) {
                    console.log(this.beforeWord.element, 'this.beforeWord.element')
                    let element1 = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(this
                        .beforeWord.element)[0];
                    console.log(element1, 'element1element1element1')
                    element1.style.backgroundColor = this.beforeWord.background
                }
                if (this.beforeColor != '') {
                    let element1 = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(
                        'check-span' + this.beforeIndex)[0];
                    element1.style.backgroundColor = this.beforeColor
                    document.getElementsByClassName('errorList')[0].children[this.beforeIndex - 1].removeAttribute(
                        'class')
                }
                this.nowIndex = key
                let element = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName('check-span' + (
                    key + 1))[0];
                this.beforeColor = element.style.backgroundColor;
                this.beforeIndex = key + 1;
                this.beforeWord = {
                    "background": element.style.backgroundColor,
                    "element": 'check-span' + (key + 1)
                }
                element.scrollIntoView({
                    behavior: "smooth",
                    block: "center",
                    inline: "nearest"
                });
                element.style.backgroundColor = '#b2caff'

            },
            update(id) {
                // console.log(chckMap, 'chckMapchckMap')
                // console.log(document.getElementsByClassName('.check-span1'), '111111111');
                UE.getEditor(this.ue).iframe.contentDocument.activeElement.focus
                document.getElementsByClassName('check-span1')
                // if (chckMap.hasOwnProperty(id)) {
                //     var tempStr = "";
                //     var data = chckMap[id];
                //     var colWordList = data.CorWord;
                //     for (var j = 0; j < colWordList.length; j++) {
                //         if (colWordList[j] != "") {
                //             tempStr = colWordList[j];
                //             break;
                //         }
                //     }
                //     if (tempStr != "") {
                //         $("#check-span" + id).text(tempStr);
                //         $("#check-span" + id).css("background-color", "#00FFFF");
                //     }

                // }
            },
            //每个子选项恢复
            btnupdate(item, key) {
                // console.log('每个子选项恢复');
                // this.myEditor.focus()
                if (this.beforeColor != '') {
                    let element1 = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(
                        'check-span' + this.beforeIndex)[0];
                    element1.style.backgroundColor = '#ffd3a3'
                }
                if (Object.keys(this.beforeWord).length != 0) {
                    let element1 = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(this
                        .beforeWord.element)[0];
                    element1.style.backgroundColor = '#ffd3a3'
                }
                let element = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName('check-span' + (
                    key + 1))[0];
                this.beforeColor = '##ffd3a3';
                this.beforeIndex = key + 1;
                this.beforeWord = {
                    "background": '#ffd3a3',
                    "element": 'check-span' + (key + 1)
                }
                var data = item;
                var tempStr = data.error_word;
                var level = data.level;
                if (tempStr != "") {
                    element.textContent = tempStr; //替换成正确的词组
                    // element.style.background = '#00FFFF';
                    if (level == 1 || level === '1000' || level === '1001' || level === '1003' || level === '1005' ||
                        level === '3001' || level === '4000' || level === '5000' || level === '7001' || level === '7002'
                    ) {
                        element.style.background = '#ffd3a3'
                    } else if (level == 3 || level === '2000' || level === '2001' || level === '3000') {
                        element.style.background = '#ffd3a3'
                    } else {
                        element.style.background = '#ffd3a3'
                    }


                }
            },
            //每个子选项修改
            btnrecover(item, key) {
                // if (this.beforeColor != '') {
                //     let element1 = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName('check-span' + this.beforeIndex)[0];
                //     element1.style.backgroundColor = this.beforeColor
                // }
                // if (Object.keys(this.beforeWord).length != 0) {
                //     let element1 = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(this.beforeWord.element)[0];
                //     element1.style.backgroundColor = this.beforeWord.background
                // }
                let element = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName('check-span' + (
                    key + 1))[0];
                // this.beforeColor = element.style.backgroundColor;
                // this.beforeIndex = key + 1;
                // this.beforeWord = {
                //     "background": element.style.backgroundColor,
                //     "element": 'check-span' + (key + 1)
                // }
                var data = item;
                var tempStr = data.right_words[0];
                var level = data.level;
                if (tempStr != "") {
                    element.textContent = tempStr; //替换成正确的词组
                    element.style.background = '#b2caff';
                } else {
                    this.$message({
                        message: tempStr,
                        type: 'warning'
                    });
                }
            },
            //清空数据
            btnClear() {
                console.log(this.chckMap, 'chckMap')
                UE.getEditor(this.ue).setContent('', false);
                this.chckMap = {}
                this.errorList = [];
            },
            //一键修改
            btnUpdateAll() {
                let chckMap = this.chckMap;
                for (var id in chckMap) {
                    if (chckMap.hasOwnProperty(id)) {
                        this.update(id);
                    }
                }
            },
            // 导出
            // exportFile(){
            //     if(this.msg==''){
            //         this.$message.error('校对内容为空!');
            //         return false;
            //     }
            //     var FileSaver = require('file-saver');
            //     var blob = new Blob([UE.getEditor(this.ue).getContent()], {type: "text/plain;charset=utf-8"});
            //     FileSaver.saveAs(blob, "校对文本.docx");
            // },
            update(id) {
                let chckMap = this.chckMap;
                if (chckMap.hasOwnProperty(id)) {
                    var tempStr = "";
                    var data = chckMap[id];
                    var colWordList = data.right_words;
                    for (var j = 0; j < colWordList.length; j++) {
                        if (colWordList[j] != "") {
                            tempStr = colWordList[j];
                            break;
                        }
                    }
                    if (tempStr != "") {
                        let element = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(
                            'check-span' + (parseInt(id)))[0];
                        element.textContent = tempStr; //替换成正确的词组
                        element.style.background = '#b2caff';
                    }

                }
            },
            //一键恢复
            btnRecoverAll() {
                let chckMap = this.chckMap;
                for (var id in chckMap) {
                    if (chckMap.hasOwnProperty(id)) {
                        this.recover(id);
                    }
                }
            },
            recover(id) {
                let chckMap = this.chckMap;
                if (chckMap.hasOwnProperty(id)) {
                    var data = chckMap[id];
                    var tempStr = data.error_word;
                    var level = data.level;
                    let element = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(
                        'check-span' + (parseInt(id)))[0];
                    if (tempStr != '') {
                        element.textContent = tempStr; //替换成正确的词组
                        if (level == 1 || level === '1000' || level === '1001' || level === '1003' || level ===
                            '1005' || level === '3001' || level === '4000' || level === '5000' || level === '7001' ||
                            level === '7002') {
                            element.style.background = '#ffd3a3'
                        } else if (level == 3 || level === '2000' || level === '2001' || level === '3000') {
                            element.style.background = '#ffd3a3'
                        } else {
                            element.style.background = '#ffd3a3'
                        }

                    }
                }
            },
            // 一键去格式
            btnRemoveStyle() {
                this.ClarBackGroup()
                this.chckMap = {}
            },
            //再次校对的时候清楚格式
            ClarBackGroup() {
                this.percentage = 0
                this.errorList = [];
                let chckMap = this.chckMap;
                if (JSON.stringify(chckMap) != JSON.stringify({})) {
                    console.log(chckMap, key)
                    var key = 1;
                    for (var item in chckMap) {
                        let element = UE.getEditor(this.ue).iframe.contentDocument.body.getElementsByClassName(
                            'check-span' + (parseInt(key)))[0];
                        var data = chckMap[key];
                        element.replaceWith(data.error_word);

                        key++;
                    }
                }

            },
            showDrawer() {
                this.drawer = true;
            },
            onClose() {
                this.drawer = false;
            },
            // 添加定时器
            addSetInterval() {
                const that = this // 声明一个变量指向vue实例this,保证作用域一致
                this.positionTimer = setInterval(() => {
                    if (10 < that.times) {
                        clearInterval(that.positionTimer)
                        that.positionTimer = null
                        // //console.log(that.times)
                    } else {
                        // 分批部署基站
                        if (that.times < 10) {
                            // that.deployBaseStation()
                            that.percentage = 90 + that.times
                            // //console.log('渲染数组的第' + that.times + '项')
                        }
                        that.times++
                    }
                }, 500)
            },
            //全选所有校对参数设置
            handleCheckAllChange(val) {
                Object.assign(this, {
                    checkedtypes: val.target.checked ? checkesOptions : [],
                    checkouterrortype: val.target.checked ? checkouterrorOptions : [],
                    isIndeterminate: false,
                    checkAll: val.target.checked,
                });

                // console.log(checkesOptions,checkouterrorOptions,'11111')
                // this.checkedtypes = val ? checkesOptions : []; //检查类型
                // this.checkouterrortype = val ? checkouterrorOptions : []; //检查参数
                // this.isIndeterminate = false;
            },
            //检查类型
            handleCheckedChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.checkes.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.checkes.length;
            },
            // 校对模式
            handleCheckedProChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.protype.length;
            },
            //Ai引擎校对
            handleCheckedAi(value) {
                console.log(value, 'mmm')
                if (value) {
                    this.checkoutAi = 1
                } else {
                    this.checkoutAi = 0
                }
                localStorage.setItem("checkoutAi", this.checkoutAi);
            },
            //检查参数
            handleCheckedErrorChange(value) {
                let checkedCount = value.length;
                this.checkAll = checkedCount === this.checkouterrortype.length;
                this.isIndeterminate = checkedCount > 0 && checkedCount < this.errortype.length;
            },
            handleClose(done) {
                this.$confirm('确认关闭？')
                    .then(_ => {
                        done();
                    })
                    .catch(_ => {});
            },
            //确定查询参数
            handleParameter() {
                // //console.log(this.checkoutAi,'mmm')
                // //console.log('查询参数')
                // //console.log(this.checkedtypes, '检查类型');
                // //console.log(this.checkouterrortype, '检查参数');
                this.drawer = false;
            },
            getPlatform() {
                getMyPlatform().then(res => {
                    // console.log(res,'res');
                    this.wordBalance = res.data.platformBalance.wordBalance
                    localStorage.setItem(
                        "myPlatform",
                        JSON.stringify(res.data)
                    );
                }).catch(err => {
                    console.log(err, 'err');
                })
            },
        },
        created() {
            // this.getPlatform()
            // if(localStorage.getItem("checkoutAi")!='null'){
            //         this.checkoutAi = parseInt(localStorage.getItem("checkoutAi"))
            // }
            // this.errorListheight= window.innerHeight-106-40-57+'px'

        },
    }
</script>

<style lang="scss" scoped>
@import "./index";
</style>